export default {
    data() {
      return {
        applicationLogo: null,
      };
    },
    async mounted() {
      this.applicationLogo =
        'data:image/jpg;base64,' +
        (await this.$applicationService.getApplicationLogo());
    },
  };